export default __webpack_public_path__ + "media/zurb/img/home/McAfee-01efd0ed1fbd3d7c8becfe181351d7a2.png";